import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getDataFromURI, getownedToken } from "../../../hooks/Tokenhook";
import { contractAddress } from '../../../config/BackendUrl';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Modal } from 'react-bootstrap';
import { ethers } from 'ethers';
import { useSelector } from 'react-redux';
import { ContractABI } from '../../../config/ABIs/ContractABI';
import DynamicCardProfile from './DynamicCardProfile';
import NFTCardPlaceholder from '../NFTCardPlaceholder';
import Pagination from '../../Pagination';
import { listNFTs } from '../../../hooks/NFTHook';

const OwnAssetProfile = ({ user, address }) => {
  const [nfts, setNfts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openModalState, setOpenModalState] = useState(false);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [price, setPrice] = useState('');
  const [receiverAddress, setReceiverAddress] = useState('');
  const [nftAction, setNftAction] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit] = useState(6);
  const [pageCount, setPageCount] = useState(0);
  const userIds = localStorage.getItem("userId");
    const { walletAddress } = useParams();

  const PROVIDER = useSelector((state) => state.valueFromHeader);
  const route = useNavigate();
  const userAddress = localStorage.getItem("WalletAddress");
  const closeModal = () => {
    setOpenModalState(false);
    setNftAction(null);
    setPrice('');
    setReceiverAddress('');
  };

  const openModal = (nft) => {
    setSelectedNFT(nft);
    setOpenModalState(true);
  };

  const fetchNfts = async (address) => {
    setIsLoading(true);
    try {
      const body = {
        page: currentPage + 1,
        limit, ownerAddress: walletAddress === undefined ? userAddress : walletAddress
      }
      console.log("body address", body,address);

      await listNFTs(body).then((OwnData) => {
        console.log("OwnData data", OwnData);

        if (OwnData.success) {
          const AddIsLikeFlag = OwnData.data.map(item => {
            const isLike = item.likes.some(like =>
              like.userId === userIds // Check if the user's ID exists in the likes array
            );
            
            return { ...item, isLike }; // Merge the `isLike` flag into the NFT object
          });
          setNfts(AddIsLikeFlag)
          setPageCount(OwnData.totalPages)
          setIsLoading(OwnData.total > 0)
        }
        else {
          setIsLoading(false)
        }
        console.log("OwnData", OwnData);
      })
    } catch (error) {
      console.error("Error fetching NFTs:", error);
      toast.error("Failed to fetch NFTs.");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    // if (user.walletAddress) {
    setTimeout(() => {
      fetchNfts(user.walletAddress);
    }, 2000);
    // }
  }, [currentPage]);

  const redeployOnMarketplace = async () => {
    if (!price || isNaN(price)) {
      toast.error("Invalid price. Please enter a valid amount.");
      return;
    }

    try {
      const wallet = await PROVIDER.getSigner();
      const contract = new ethers.Contract(contractAddress, ContractABI, wallet);
      const priceInEther = ethers.parseEther(price);
      const transaction = await contract.addNftToMarket(selectedNFT.tokenId, priceInEther);
      const receipt = await transaction.wait();
      if (receipt) {
        toast.success("NFT added to the marketplace successfully!");
        setTimeout(() => route('/marketplace'), 2000);
      }
    } catch (error) {
      console.error("Error redeploying NFT:", error);
      toast.error("Error redeploying NFT: " + error.message);
    }
  };

  const sendNFT = async () => {
    if (!receiverAddress || !ethers.isAddress(receiverAddress)) {
      toast.error("Invalid recipient address.");
      return;
    }

    try {
      const wallet = await PROVIDER.getSigner();
      const contract = new ethers.Contract(contractAddress, ContractABI, wallet);
      const transaction = await contract.transferFrom(userAddress, receiverAddress, selectedNFT.tokenId);
      const receipt = await transaction.wait();
      if (receipt) {
        closeModal();
        toast.success("NFT sent successfully!");
        fetchNfts(user.walletAddress);
      }
    } catch (error) {
      console.error("Error sending NFT:", error);
      toast.error("Error sending NFT: " + error.message);
    }
  };

  const handlePageChange = (selectedItem) => {
    console.log("sele", selectedItem);

    // fetchNfts(user.address)
    setCurrentPage(selectedItem.selected);
  };

  console.log("user, address at Own Profile", user, nfts);

  const renderNFTs = () => {
    if (isLoading) {
      return [...Array(limit)].map((_, index) => (
        <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
          <NFTCardPlaceholder />
        </div>
      ));
    }

    if (nfts.length === 0) {
      return <h3>No NFTs available!</h3>;
    }
    const openModal = (nft) => {
      console.log("NFT", nft);

      setSelectedNFT(nft);
      setOpenModalState(true);
    };
    console.log("paginatedNFTs", nfts);

    return (
      <>
        {nfts.map((nft, index) => (
          <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 card-hover-effect" key={index}>
            <DynamicCardProfile
              NFTLink={`/nftdetails/${nft.contractAddress}/${nft._id}`}
              contractAddress={nft.contractAddress}
              mediaUrl={nft.imageUri}
              assetType={nft.assetType}
              title={nft.title}
              likes={nft.totalLikes}
              isLiked={nft.isLike}
              tokenId={nft.tokenId}
              isListed={nft.listed}
              button={ walletAddress === undefined ? true : false}
              buttonMessage={nft.listed ? 'Listed' : "Trade"}
              onTrade={openModal}
              nftId={nft._id}
              // isLazy={nft.type = "Lazy Mint" ? true : false}
            />
          </div>
        ))}
        {pageCount > 1 && (
          <Pagination
            pageCount={pageCount}
            onPageChange={handlePageChange}
            currentPage={currentPage}
          />
        )}
      </>
    );
  };

  return (
    <div className="row mb-30_reset">
      {renderNFTs()}
      <Modal show={openModalState} size="lg" onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select an action for the NFT 231</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Select an option to send or add to the market</h3>
          {!nftAction && (
            <div className="my-2">
              <Button onClick={() => setNftAction('send')}>Send</Button>
              <Button onClick={() => setNftAction('market')} className="mx-3">
                Add to Market
              </Button>
            </div>
          )}
          {nftAction === 'send' && (
            <div className='my-4'>
              <h4>Enter recipient's wallet address</h4>
              <input
                type="text"
                className="form-control"
                placeholder="Wallet Address"
                value={receiverAddress}
                onChange={(e) => setReceiverAddress(e.target.value)}
              />
            </div>
          )}
          {nftAction === 'market' && (
            <div className='my-4'>
              <h4>Set Price for Redeployment</h4>
              <input
                type="text"
                className="form-control"
                placeholder="Price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={closeModal}>Cancel</Button>
          <Button
            onClick={() => {
              if (nftAction === 'market') {
                redeployOnMarketplace();
              } else if (nftAction === 'send') {
                sendNFT();
              }
            }}
          >
            {nftAction === 'market' ? 'Add to Market' : 'Send'}
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default OwnAssetProfile;
